
import React from 'react';
import * as Styled from './styles.module';
import { Modal } from '../../../components/UIKitComponents/Modal/Modal';
import { Icon } from '../../../components/UIKitComponents/Icon/Icon';
import { Agent, Department } from '../../../models';
import { Phone } from '../../../utils/Phone';

interface ISenderListProps {
  show: boolean;
  onHide(): void;
  onChangeSender(sender: Department): void;
  savedSenderData: Department;
  departments: any[];
  agent: Agent;
}

export class SenderList extends React.Component<ISenderListProps> {

  state: any = {
    temporarySelectedSender: null,
  }

  restoreState() {
    this.setState({
      temporarySelectedSender: null,
    });
  }

  closeSenderList() {
    this.restoreState();
    this.props.onHide();
  }

  moveSelectedItemToTop(): Department[] {
    if (!this.props.agent?.phone) return this.props.departments;

    const savedSenderData: any = this.props.savedSenderData || {};
    const agentPhoneItem: Department = {
      id: -1,
      name: 'Personal',
      phone: new Phone(this.props.agent.phone || '').normalized(),
    };
    const sendersList = [agentPhoneItem, ...this.props.departments];
    const selectedItemIndex = sendersList.findIndex(it => it.id === savedSenderData.id);
    const listWithSelectedItem = sendersList.splice(selectedItemIndex, 1);

    return listWithSelectedItem.concat(sendersList);
  }

  renderDepartmentPhones() {
    const savedSenderData: any = this.props.savedSenderData || {};
    const sendersList = this.moveSelectedItemToTop();

    return sendersList
      .filter(it => it.phone && it.phone.length > 0)
      .map(it => {
        return (
          <Styled.PhoneItem
            key={it.id}
            selected={this.state.temporarySelectedSender?.id === it.id}
            onClick={() => this.setState({ temporarySelectedSender: it })}>
            <Styled.PhoneItemTitle>
              {savedSenderData.id === it.id ? <Icon color='#2EC959' icon='check' /> : null}
              {it.name}
            </Styled.PhoneItemTitle>
            <Styled.PhoneItemValue>{it.phone}</Styled.PhoneItemValue>
          </Styled.PhoneItem>
        )
      });
  }

  render() {
    const selectedSender = this.state.temporarySelectedSender;
    const savedSenderData = this.props.savedSenderData || new Department();
    const isActiveChangeBtn = selectedSender && savedSenderData.id !== selectedSender?.id;

    return (
      <Modal
        width={650}
        title='Change Sender ID'
        show={this.props.show}
        onHide={() => this.closeSenderList()}
        darkShadow
        closeBtn
      >
        <Styled.PhoneList>
          {this.renderDepartmentPhones()}
        </Styled.PhoneList>

        <Styled.ButtonsRow>
          <Styled.CancelBtn
            className="typo typo-text-14"
            onSubmit={() => this.closeSenderList()}
            size='medium'
          >
            Cancel
          </Styled.CancelBtn>

          <Styled.ChangeBtn
            className="typo typo-text-14"
            onSubmit={() => {
              this.props.onChangeSender(selectedSender);
              this.closeSenderList();
            }}
            disabled={!isActiveChangeBtn}
            size='medium'
          >
            Change
          </Styled.ChangeBtn>
        </Styled.ButtonsRow>

      </Modal>
    );
  }
}
